// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"ab4a1e73","453":"9f1c8364"}[chunkId] + ".chunk.js";
};